import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listPropertyCalendarSyncImage } from 'config/imageUrls';

import { ContentSection, DividerTemp } from './styles';
export const CalendarSync = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5} lg={4}>
            <Typography variant="h2" mb={2}>
              Calendars Stay in Sync
            </Typography>
            <Typography>
              It is easy to include the allura booking channel, even if your vacation rental property is advertised on
              multiple hosting platforms at the same time.
            </Typography>
            <ul>
              <li>Sync the iCalendars (ics) between platforms.</li>
              <li>Blocked dates are shared automatically.</li>
              <li>Each platform updates availability.</li>
            </ul>
            <Typography>
              When reservations (or any blocking event) occurs on a booking platform, the synced calendars are always
              listening and will update automatically.
            </Typography>
          </Grid>
          <Grid item xs={12} md={7} lg={8} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src={listPropertyCalendarSyncImage} width="100%" />
          </Grid>
        </Grid>
      </ContentSection>

      <ContentSection>
        <DividerTemp />
      </ContentSection>
    </>
  );
};
